import * as tslib_1 from "tslib";
import 'jodit/build/jodit.min.css';
import * as React from "react";
var Jodit = require('jodit');
var JoditWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(JoditWrapper, _super);
    function JoditWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.firstBoot = true;
        return _this;
    }
    JoditWrapper.prototype.componentDidMount = function () {
        var _a = this.props, onContentUpdate = _a.onContentUpdate, initValue = _a.initValue;
        this.jodit = new Jodit.Jodit(this.editorRef, {
            language: 'ru',
            removeButtons: ['font', 'fontsize', 'brush', 'paragraph', 'undo', 'redo', 'about'],
        });
        this.jodit.value = initValue;
        this.jodit.events.on('change', function (content) { return onContentUpdate && onContentUpdate(content); });
    };
    JoditWrapper.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.firstBoot) {
            this.jodit.value = nextProps.initValue;
            this.firstBoot = false;
        }
    };
    JoditWrapper.prototype.render = function () {
        var _this = this;
        return (React.createElement("textarea", { ref: function (ref) { return _this.editorRef = ref; } }));
    };
    return JoditWrapper;
}(React.Component));
export default JoditWrapper;



//////////////////
// WEBPACK FOOTER
// ./src/views/news/editor.tsx
// module id = 547
// module chunks = 0